import { useEffect, useRef } from 'react';

/**
 * @param {string} extension
 * @param {string} imageType
 * @param {boolean} isThumbnail
 * @param {string} productSku
 * @param {number} size
 * @param {number} version
 * */
export function getImageUrl(
  extension,
  imageType,
  isThumbnail,
  productSku,
  size,
  version,
) {
  return `https://res.cloudinary.com/fftech/w_${size}${
    isThumbnail ? ',c_thumb' : ''
  }/${
    version ? `v${version}/` : ''
  }Products/${productSku.toLowerCase()}/${imageType}/Image.${extension}`;
}

/** @param {function} onLoadFn */
export function useOnLoad(onLoadFn) {
  /**
   * if image was loaded from disk cache, chance it has already loaded before we can attach
   * the "onLoadFn". so just in case, lets check for that when this component mounts
   */
  /** @type {React.MutableRefObject<HTMLImageElement|null>} imgRef */
  const imgRef = useRef(null);
  useEffect(() => {
    if (imgRef.current?.complete && imgRef.current?.naturalHeight !== 0) {
      onLoadFn();
    }
  }, []);

  return imgRef;
}
